$(document).ready(function() {
 
  $('.hm-banner-slider').owlCarousel({
    autoplay:true,
    autoplayTimeout:5000,
    autoplayHoverPause:false,
    loop:true,
    margin:10,
    nav:false,
    dots:false,
    singleItem:true,
    animateOut: 'fadeOut',
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})
 
});


// img popup script
document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("imgModal");
  const modalImg = document.getElementById("modalImg");
  const closeBtn = document.querySelector(".img-modal-close");
  const body = document.body;

  if (!modal || !modalImg || !closeBtn) return;

  document.querySelectorAll(".img-popup-trig img").forEach(img => {
    img.style.cursor = "pointer";

    img.addEventListener("click", function () {
      modal.style.display = "flex";
      modalImg.src = this.src;

      // add class when popup opens
      body.classList.add("img-popup-open");
    });
  });

  function closeModal() {
    modal.style.display = "none";

    // remove class when popup closes
    body.classList.remove("img-popup-open");
  }

  closeBtn.addEventListener("click", closeModal);

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });

});

